var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1043.267,
    height: 162.704,
    viewBox: "0 0 1043.267 162.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7542",
    "data-name": "Rectangle 7542",
    width: 1043.267,
    height: 162.704,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17644",
    "data-name": "Group 17644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17643",
    "data-name": "Group 17643",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57722",
    "data-name": "Path 57722",
    d: "M69.408,101.111c30.822,0,47.807-18.242,53.885-27.048l-2.853-2.99C111.726,80.117,95.2,92.3,69.408,92.3c-31.585,0-55.195-14.93-66.164-39.959,7.778,30.688,32.447,48.765,66.164,48.765",
    transform: "translate(3.557 57.401)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57723",
    "data-name": "Path 57723",
    d: "M74.963,37.324a52.551,52.551,0,0,0-.73-8.646l-26.1,3.986-1.77.27A34.471,34.471,0,0,1,47.5,41.518Z",
    transform: "translate(50.839 31.447)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57724",
    "data-name": "Path 57724",
    d: "M49.131,25.107c12.1,0,19.752,5.849,24.056,13.253C71.934,29.159,65.929,16.3,49.131,16.3,33.675,16.3,22.4,27.348,18.867,44.777c6.25-12.594,17.362-19.67,30.264-19.67",
    transform: "translate(20.689 17.874)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57725",
    "data-name": "Path 57725",
    d: "M124,85.93l2.853,2.99c-6.078,8.806-23.063,27.048-53.885,27.048C39.248,115.968,14.58,97.892,6.8,67.2A83.533,83.533,0,0,1,.222,38.8C.086,40.938,0,43.1,0,45.309c0,45.471,28.642,74.853,72.966,74.853,34.715,0,52.662-22.09,57.336-28.86l1.939-2.809-2.357-2.468-3.065-3.21c-.828.975-1.767,2.021-2.822,3.116",
    transform: "translate(0 42.543)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57726",
    "data-name": "Path 57726",
    d: "M106.366,37.437,105,37.645a52.57,52.57,0,0,1,.73,8.646L78.27,50.484A34.476,34.476,0,0,0,77.131,41.9l-3.055.468V37.485a27.545,27.545,0,0,0-.268-3.732C69.5,26.35,61.847,20.5,49.752,20.5c-12.9,0-24.014,7.076-30.264,19.672a61.346,61.346,0,0,0-1.187,12.2c0,2.407.113,4.671.323,6.8C20.6,38.32,32.591,24.694,49.752,24.694c19.24,0,24.325,16.871,24.325,25.79v4.883l4.824-.738,27.465-4.193,3.56-.543v-3.6a57.59,57.59,0,0,0-.767-9.282Z",
    transform: "translate(20.069 22.48)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57727",
    "data-name": "Path 57727",
    d: "M125.719,25.107c14,0,25.409,7,31.73,19.547C153.849,27.1,142.2,16.3,125.719,16.3c-16.634,0-28.379,10.871-31.963,28.518,6.365-12.653,17.9-19.712,31.963-19.712",
    transform: "translate(102.812 17.874)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57728",
    "data-name": "Path 57728",
    d: "M142.981,101.4c32.606,0,57.107-18.469,64.77-49.306-10.881,25.123-34.246,40.5-64.77,40.5-30.619,0-54.056-15.381-64.967-40.51,7.709,30.843,32.353,49.316,64.967,49.316",
    transform: "translate(85.55 57.113)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57729",
    "data-name": "Path 57729",
    d: "M126.329,20.5c-14.062,0-25.6,7.059-31.963,19.712A59.869,59.869,0,0,0,93.2,52.162a64.025,64.025,0,0,0,.359,6.516c2.111-20.84,14.483-33.984,32.772-33.984,18.171,0,30.466,13.144,32.564,33.984a64.654,64.654,0,0,0,.354-6.516,60.326,60.326,0,0,0-1.189-12.114C151.738,27.5,140.328,20.5,126.329,20.5",
    transform: "translate(102.201 22.48)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57730",
    "data-name": "Path 57730",
    d: "M211.278,66.757c-7.663,30.837-32.164,49.306-64.77,49.306S89.25,97.59,81.541,66.745a83.707,83.707,0,0,1-6.514-28.034c-.138,2.128-.229,4.281-.229,6.481,0,44.9,28.818,75.064,71.71,75.064,42.764,0,71.5-30.166,71.5-75.064,0-2.2-.09-4.353-.229-6.481a83.928,83.928,0,0,1-6.5,28.046",
    transform: "translate(82.023 42.449)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57731",
    "data-name": "Path 57731",
    d: "M234.059,122.507h28.3V113.7H231.82l-1.245-1.86L185.882,45.118c-2.658-4.088-5.711-9.02-8.527-13.624.029,1.522.052,3.2.067,5.053C181,42.442,185.605,50,189.4,55.831Z",
    transform: "translate(194.486 34.535)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57732",
    "data-name": "Path 57732",
    d: "M190.523,79.51,190.5,70.7H161.8V79.51Z",
    transform: "translate(177.426 77.533)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57733",
    "data-name": "Path 57733",
    d: "M202.316,67.927,202.134,6.9h-.04l.013,4.2.2,67.468c.063.107.128.21.191.317-.115-3.386-.185-7.1-.185-10.963",
    transform: "translate(221.615 7.567)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57734",
    "data-name": "Path 57734",
    d: "M192.717,70.7h-.027l.027,8.806H163.991V70.7H159.8v13h37.124L196.91,79.5l-.027-8.793Z",
    transform: "translate(175.233 77.533)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57735",
    "data-name": "Path 57735",
    d: "M262.328,111.059v8.806h-28.3L189.363,53.188C185.57,47.354,180.968,39.8,177.387,33.9c.017,1.843.025,3.858.025,6.063l.006,2.046c2.788,4.558,5.8,9.42,8.428,13.46L230.54,122.2l1.245,1.86h34.736v-13Z",
    transform: "translate(194.521 37.178)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7536",
    "data-name": "Rectangle 7536",
    width: 37.953,
    height: 8.806,
    transform: "translate(494.79 34.384)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7537",
    "data-name": "Rectangle 7537",
    width: 37.95,
    height: 8.806,
    transform: "translate(570.9 34.384)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7538",
    "data-name": "Rectangle 7538",
    width: 29.774,
    height: 8.806,
    transform: "translate(536.935 148.237)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57736",
    "data-name": "Path 57736",
    d: "M276.142,25.207H238.19V16.4H234v13h42.146Z",
    transform: "translate(256.599 17.984)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57737",
    "data-name": "Path 57737",
    d: "M310.25,16.4v8.806H272.3V29.4h42.144v-13Z",
    transform: "translate(298.601 17.984)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57738",
    "data-name": "Path 57738",
    d: "M288.066,70.7V79.51H258.292V70.7H254.1v13h38.16v-13Z",
    transform: "translate(278.643 77.533)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57739",
    "data-name": "Path 57739",
    d: "M361.678,56.6H317.652l-2.872,8.806H364.55Z",
    transform: "translate(345.185 62.069)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57740",
    "data-name": "Path 57740",
    d: "M374.895,79.51,371.786,70.7H341.83L344.7,79.51Z",
    transform: "translate(374.848 77.533)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57741",
    "data-name": "Path 57741",
    d: "M326,79.51l2.872-8.806H298.719L295.6,79.51Z",
    transform: "translate(324.149 77.533)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57742",
    "data-name": "Path 57742",
    d: "M325.144,61.319l7.24-22.4c.178-.566.361-1.138.543-1.719.168.526.338,1.042.5,1.547L340.8,61.319h4.248L333.43,25.744c-.166-.505-.335-1.023-.5-1.549-.182.583-.365,1.155-.543,1.721l-11.437,35.4Z",
    transform: "translate(351.948 26.531)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57743",
    "data-name": "Path 57743",
    d: "M425.589,81.561l3.109,8.806H398.507l-2.874-8.806h-.17l-.943-2.893L388.691,60.8H338.918l-5.828,17.865-.943,2.893h-.17L329.1,90.367H298.7l3.122-8.806h-4.449l-2.625,7.405-1.983,5.594h39.38l.943-2.893L341.792,65h44.026l8.7,26.671.943,2.893h39.162l-1.973-5.59-2.617-7.409h-4.447Z",
    transform: "translate(321.045 66.675)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57744",
    "data-name": "Path 57744",
    d: "M417.129,25.107c12.1,0,19.752,5.849,24.056,13.253-1.254-9.2-7.258-22.058-24.056-22.058-15.456,0-26.727,11.047-30.264,28.476,6.25-12.594,17.362-19.67,30.264-19.67",
    transform: "translate(424.233 17.874)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57745",
    "data-name": "Path 57745",
    d: "M437.406,101.111c30.822,0,47.807-18.242,53.885-27.048l-2.853-2.99C479.724,80.117,463.2,92.3,437.406,92.3c-31.585,0-55.195-14.93-66.164-39.959,7.778,30.688,32.447,48.765,66.164,48.765",
    transform: "translate(407.101 57.401)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57746",
    "data-name": "Path 57746",
    d: "M442.961,37.324a52.554,52.554,0,0,0-.73-8.646l-26.1,3.986-1.77.27a34.47,34.47,0,0,1,1.136,8.583Z",
    transform: "translate(454.383 31.447)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57747",
    "data-name": "Path 57747",
    d: "M474.364,37.437,473,37.645a52.573,52.573,0,0,1,.73,8.646l-27.463,4.193a34.476,34.476,0,0,0-1.138-8.583l-3.055.468V37.485a27.543,27.543,0,0,0-.268-3.732C437.5,26.35,429.845,20.5,417.75,20.5c-12.9,0-24.014,7.076-30.264,19.672a61.348,61.348,0,0,0-1.187,12.2c0,2.407.113,4.671.323,6.8C388.6,38.32,400.589,24.694,417.75,24.694c19.24,0,24.325,16.871,24.325,25.79v4.883l4.824-.738,27.465-4.193,3.56-.543v-3.6a57.592,57.592,0,0,0-.767-9.282Z",
    transform: "translate(423.613 22.48)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57748",
    "data-name": "Path 57748",
    d: "M491.995,85.93l2.853,2.99c-6.078,8.806-23.062,27.048-53.885,27.048-33.717,0-58.386-18.077-66.164-48.765A83.533,83.533,0,0,1,368.22,38.8c-.136,2.141-.222,4.3-.222,6.512,0,45.471,28.642,74.853,72.966,74.853,34.715,0,52.662-22.09,57.336-28.86l1.939-2.809-2.357-2.468-3.065-3.21c-.828.975-1.767,2.021-2.822,3.116",
    transform: "translate(403.544 42.543)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7539",
    "data-name": "Rectangle 7539",
    width: 37.952,
    height: 8.806,
    transform: "translate(925.008 34.384)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7540",
    "data-name": "Rectangle 7540",
    width: 37.952,
    height: 8.806,
    transform: "translate(1001.121 34.384)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7541",
    "data-name": "Rectangle 7541",
    width: 29.774,
    height: 8.806,
    transform: "translate(967.154 148.237)",
    fill: "#bb3a07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57749",
    "data-name": "Path 57749",
    d: "M515.451,16.4v8.806H477.5V29.4h42.146v-13Z",
    transform: "translate(523.621 17.984)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57750",
    "data-name": "Path 57750",
    d: "M493.265,70.7V79.51H463.491V70.7H459.3v13h38.16v-13Z",
    transform: "translate(503.663 77.533)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57751",
    "data-name": "Path 57751",
    d: "M481.342,25.207H443.389V16.4H439.2v13h42.146Z",
    transform: "translate(481.619 17.984)",
    fill: "#7f2602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57752",
    "data-name": "Path 57752",
    d: "M124.657,116.271,107.046,97.818c-5.661,7.969-17.613,19.71-35.435,19.71-20.549,0-39.628-13-39.628-44.869,0-28.1,15.727-44.871,35.644-44.871,20.756,0,28.516,17.194,28.516,29.983l27.465-4.193C123.609,31.354,108.723,2,67.21,2,29.258,2,2,29.465,2,72.659c0,43.821,27.675,70.659,68.772,70.659,30.822,0,47.807-18.242,53.885-27.048",
    transform: "translate(2.193 2.192)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57753",
    "data-name": "Path 57753",
    d: "M132.24,118.038l-2.357-2.47L112.273,97.116l-3.51-3.675-2.944,4.143c-3.833,5.4-14.622,17.945-32.015,17.945-7.783,0-32.046-2.575-35.112-33.873-.21-2.132-.323-4.4-.323-6.8a61.346,61.346,0,0,1,1.187-12.2c3.537-17.429,14.808-28.478,30.264-28.478,16.8,0,22.8,12.858,24.056,22.058a27.569,27.569,0,0,1,.268,3.732v4.883L97.2,64.38l1.77-.27,26.1-3.986,1.363-.208,2.793-.426.767-.117v-3.6C130,28.91,111.033,0,69.4,0,49.66,0,31.942,7.263,19.515,20.45,6.749,34,0,52.809,0,74.853c0,2.206.088,4.359.222,6.489a83.52,83.52,0,0,0,6.579,28.4c10.969,25.029,34.579,39.959,66.164,39.959,25.79,0,42.318-12.187,51.031-21.23,1.055-1.1,1.994-2.141,2.822-3.118,1.539-1.814,2.7-3.38,3.482-4.512ZM72.966,145.512c-41.1,0-68.772-26.838-68.772-70.659,0-43.194,27.258-70.659,65.21-70.659,41.515,0,56.4,29.354,56.4,51.578L98.339,59.965c0-12.789-7.762-29.983-28.518-29.983-19.918,0-35.644,16.775-35.644,44.871,0,31.87,19.081,44.869,39.628,44.869,17.821,0,29.776-11.741,35.435-19.71l17.611,18.452c-6.078,8.806-23.063,27.048-53.885,27.048",
    transform: "translate(0 -0.001)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57754",
    "data-name": "Path 57754",
    d: "M144.315,2C104.685,2,76.8,29.258,76.8,72.45c0,43.611,27.887,70.869,67.517,70.869s67.3-27.258,67.3-70.869c0-43.192-27.679-70.45-67.3-70.45m0,115.319c-21.6,0-37.324-16.563-37.324-44.869,0-28.1,15.727-44.662,37.324-44.662s37.112,16.565,37.112,44.662c0,28.306-15.517,44.869-37.112,44.869",
    transform: "translate(84.216 2.192)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57755",
    "data-name": "Path 57755",
    d: "M146.507,0C103.615,0,74.8,30,74.8,74.643c0,2.212.09,4.378.229,6.518a83.719,83.719,0,0,0,6.514,28.034c10.911,25.132,34.348,40.51,64.967,40.51,30.524,0,53.889-15.374,64.77-40.5a83.877,83.877,0,0,0,6.5-28.046c.138-2.141.229-4.306.229-6.518C218,30,189.273,0,146.507,0m67.3,74.643c0,43.611-27.677,70.869-67.3,70.869S78.99,118.254,78.99,74.643c0-43.192,27.887-70.45,67.517-70.45s67.3,27.258,67.3,70.45",
    transform: "translate(82.022 -0.001)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57756",
    "data-name": "Path 57756",
    d: "M128.523,14.3c-21.6,0-37.324,16.563-37.324,44.66,0,28.306,15.727,44.869,37.324,44.869s37.112-16.563,37.112-44.869c0-28.1-15.517-44.66-37.112-44.66m32.919,44.66c0,2.256-.145,4.411-.354,6.516-2.1,20.949-14.393,34.16-32.564,34.16-18.289,0-30.661-13.211-32.774-34.16a64.643,64.643,0,0,1-.356-6.516A59.869,59.869,0,0,1,96.56,47.012c3.581-17.647,15.328-28.518,31.963-28.518,16.477,0,28.13,10.8,31.728,28.352a60.172,60.172,0,0,1,1.191,12.114",
    transform: "translate(100.008 15.681)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57757",
    "data-name": "Path 57757",
    d: "M250.7,72.521c0,11.531.631,22.016,1.26,25.79l-1.26.629c-2.306-4.193-8.6-15.515-15.724-26.209L188.217,2.7H161.8V141.083h28.725l-.21-66.886c0-11.112-.208-21.807-1.048-24.952l1.258-.627c3.352,5.451,10.483,17.4,15.934,25.788l44.662,66.676h28.3V2.7H250.488Z",
    transform: "translate(177.426 2.96)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57758",
    "data-name": "Path 57758",
    d: "M252.682.7h-4.206l.013,4.206.027,8.793.182,61.026c0,3.866.069,7.577.185,10.965-.065-.109-.128-.212-.193-.319-2.761-4.619-5.468-8.925-8.034-12.775L193.9,2.564,192.655.7H159.8V147.47h37.126l-.013-4.208-.2-64.837-.006-2.046c0-2.206-.008-4.22-.025-6.065s-.038-3.529-.067-5.051c2.816,4.6,5.868,9.535,8.527,13.624l44.693,66.724,1.245,1.86h34.736V.7H252.682Zm28.935,17.192V143.277h-28.3L208.652,76.6c-5.451-8.388-12.582-20.339-15.934-25.79l-1.258.629c.839,3.145,1.048,13.84,1.048,24.952l.21,66.886H163.99V4.893h26.421l46.756,70.03c7.128,10.693,13.418,22.014,15.724,26.209l1.258-.631c-.627-3.772-1.258-14.257-1.258-25.788l-.21-69.821h28.935Z",
    transform: "translate(175.232 0.767)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57759",
    "data-name": "Path 57759",
    d: "M236,15.7V27.231h42.146V141.084h29.774V27.231h42.141V2.7H236Z",
    transform: "translate(258.793 2.96)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57760",
    "data-name": "Path 57760",
    d: "M238.19.7H234V33.616h42.144V147.47H314.3V33.616h42.144V.7H238.19ZM352.251,17.892V29.423H310.108V143.277H280.334V29.423H238.19V4.893H352.251Z",
    transform: "translate(256.599 0.767)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57761",
    "data-name": "Path 57761",
    d: "M344.663,2.7,295.6,141.083H326l9.646-29.564h50.111l9.646,29.564h30.191L376.742,2.7Zm-1.679,86.384L356.194,48.2a118.44,118.44,0,0,0,4.193-15.936h.629a141.519,141.519,0,0,0,4.193,15.727l13.418,41.1Z",
    transform: "translate(324.148 2.96)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57762",
    "data-name": "Path 57762",
    d: "M432.652,141.88,383.8,3.5,382.814.7H344.8l-.99,2.793L294.748,141.876l-1.983,5.594h39.382l.943-2.893,5.829-17.865,2.872-8.806h44.026l2.874,8.806,5.829,17.865.943,2.893h39.16Zm-34.145,1.4-9.646-29.564H338.75L329.1,143.277H298.7L347.767,4.893h32.08L428.7,143.277Z",
    transform: "translate(321.044 0.767)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57763",
    "data-name": "Path 57763",
    d: "M336.231,16.8H335.6a118.173,118.173,0,0,1-4.193,15.934L318.2,73.621h35.644l-13.418-41.1A142.071,142.071,0,0,1,336.231,16.8M335.4,34.025q.27-.849.543-1.719.252.789.505,1.547l11.615,35.575h-24.1Z",
    transform: "translate(348.934 18.423)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57764",
    "data-name": "Path 57764",
    d: "M492.655,116.271,475.044,97.818c-5.661,7.969-17.613,19.71-35.435,19.71-20.549,0-39.628-13-39.628-44.869,0-28.1,15.727-44.871,35.644-44.871,20.756,0,28.516,17.194,28.516,29.983l27.465-4.193C491.607,31.354,476.721,2,435.208,2,397.256,2,370,29.465,370,72.659c0,43.821,27.675,70.659,68.772,70.659,30.822,0,47.807-18.242,53.885-27.048",
    transform: "translate(405.737 2.192)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57765",
    "data-name": "Path 57765",
    d: "M500.238,118.038l-2.357-2.47L480.271,97.116l-3.51-3.675-2.944,4.143c-3.833,5.4-14.622,17.945-32.015,17.945-7.783,0-32.046-2.575-35.112-33.873-.21-2.132-.323-4.4-.323-6.8a61.348,61.348,0,0,1,1.187-12.2c3.537-17.429,14.808-28.478,30.264-28.478,16.8,0,22.8,12.858,24.056,22.058a27.566,27.566,0,0,1,.268,3.732v4.883l3.055-.468,1.77-.27,26.1-3.986,1.363-.208,2.793-.426.767-.117v-3.6C497.993,28.91,479.031,0,437.4,0c-19.744,0-37.462,7.263-49.888,20.45C374.747,34,368,52.809,368,74.853c0,2.206.088,4.359.222,6.489a83.509,83.509,0,0,0,6.579,28.4c10.969,25.029,34.579,39.959,66.164,39.959,25.79,0,42.318-12.187,51.031-21.23,1.055-1.1,1.994-2.141,2.822-3.118,1.539-1.814,2.7-3.38,3.482-4.512Zm-59.275,27.474c-41.1,0-68.772-26.838-68.772-70.659,0-43.194,27.258-70.659,65.21-70.659,41.515,0,56.4,29.354,56.4,51.578l-27.463,4.193c0-12.789-7.762-29.983-28.518-29.983-19.918,0-35.644,16.775-35.644,44.871,0,31.87,19.081,44.869,39.628,44.869,17.821,0,29.776-11.741,35.435-19.71l17.611,18.452c-6.078,8.806-23.062,27.048-53.885,27.048",
    transform: "translate(403.544 -0.001)",
    fill: "#fcb01a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57766",
    "data-name": "Path 57766",
    d: "M441.2,15.7V27.231h42.146V141.084h29.774V27.231h42.144V2.7H441.2Z",
    transform: "translate(483.813 2.96)",
    fill: "#f95b1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57767",
    "data-name": "Path 57767",
    d: "M557.453.7H439.2V33.616h42.144V147.47H519.5V33.616h42.146V.7Zm0,17.192V29.423H515.307V143.277H485.534V29.423H443.39V4.893H557.453Z",
    transform: "translate(481.62 0.767)",
    fill: "#fcb01a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/CONTACT.8272c0305f44adc3b503eb573162fd48.svg";
export { ForwardRef as ReactComponent };